'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { initTracking, page } from '@/lib/track';

// Mounts once in the root layout. Installs global autocapture on first mount and
// fires a page view on every route change. Renders nothing.
export default function Tracker() {
  const pathname = usePathname();

  useEffect(() => {
    initTracking();
  }, []);

  // initTracking() already sends the entry page view; this fires on subsequent
  // client-side navigations. (The guard in page() no-ops before init completes.)
  useEffect(() => {
    page();
  }, [pathname]);

  return null;
}
